import script from "./SeletorCor.vue?vue&type=script&setup=true&lang=js"
export * from "./SeletorCor.vue?vue&type=script&setup=true&lang=js"

import "./SeletorCor.vue?vue&type=style&index=0&id=3436d716&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3436d716"]])

export default __exports__